import React from "react";
import locale from "@bonliva-crm/locale";
import { Body } from "@components";

export function InvoiceNotFound() {
  return (
    <div style={{ padding: 8 }}>
      <Body style={{ textAlign: "center" }}>{locale.NothingFound}</Body>
    </div>
  );
}
